import React from 'react'
import {connect} from 'react-redux'
import TabContent from '../../components/ConsumerApi/TabContent'
import { receiveConsumerApiData } from '../../actions/statusesActions'

const mapStateToProps = (state) => {
  return {
    consumerApiData: state.adminStatuses.consumerApi
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConsumerApiData: (data) => {
      dispatch(receiveConsumerApiData(data))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TabContent)


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/containers/ConsumerApi/TabContentContainer.jsx